import { render, staticRenderFns } from "./ConfigSupplier.vue?vue&type=template&id=6c57912d&scoped=true"
import script from "./ConfigSupplier.vue?vue&type=script&lang=js"
export * from "./ConfigSupplier.vue?vue&type=script&lang=js"
import style0 from "./ConfigSupplier.vue?vue&type=style&index=0&id=6c57912d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c57912d",
  null
  
)

export default component.exports